import { formatMoney } from '@theme/money-formatting';

/** @type {Promise<void> | undefined} */
let moneyReadyPromise;

/**
 * Resolves when client-side money formatting is available.
 *
 * @returns {Promise<void>}
 */
window.allerasWhenMoneyReady = function allerasWhenMoneyReady() {
  if (typeof window.allerasFormatMoney === 'function') {
    return Promise.resolve();
  }

  if (!moneyReadyPromise) {
    moneyReadyPromise = new Promise(function (resolve) {
      if (typeof window.allerasFormatMoney === 'function') {
        resolve();
        return;
      }

      document.addEventListener('alleras:money-ready', function onReady() {
        document.removeEventListener('alleras:money-ready', onReady);
        resolve();
      });
    });
  }

  return moneyReadyPromise;
};

/**
 * Formats cents using the active Shopify money format template.
 *
 * @param {number|string} cents
 * @param {string} [format]
 * @param {string} [currency]
 * @returns {string}
 */
/**
 * Drops trailing .00 / ,00 from formatted money (matches Liquid money_without_trailing_zeros).
 * Leaves genuine fractional amounts (e.g. £12.50) unchanged.
 *
 * @param {string} formatted
 * @returns {string}
 */
function withoutTrailingZeros(formatted) {
  return String(formatted || '').replace(/([.,]00)(?=\D|$)/g, '');
}

window.allerasFormatMoney = function allerasFormatMoney(cents, format, currency) {
  const moneyFormat = format || '${{amount}}';
  const activeCurrency =
    currency ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'USD';

  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    const formatted = window.Shopify.formatMoney(cents, moneyFormat);
    if (formatted && !formatted.includes('{{')) {
      return withoutTrailingZeros(formatted);
    }
  }

  return withoutTrailingZeros(formatMoney(Number(cents), moneyFormat, activeCurrency));
};

document.dispatchEvent(new CustomEvent('alleras:money-ready'));
